import MobileDetect from 'mobile-detect';
import { detect } from 'detect-browser';

const browser = detect();

const detectMobile = new MobileDetect(window.navigator.userAgent);

// eslint-disable-next-line import/prefer-default-export
export const isMobile = detectMobile.mobile() || detectMobile.tablet();
export const isIe = browser.name === 'ie';
